export default __webpack_public_path__ + "static/media/aigaleo-remove.a7f95625.png";